import { NOTE_TYPE_LABELS } from '../constants/schemas';

const NOTE_TYPE_LABELS_AR = {
  progress_note: 'ملاحظة التقدم',
  vitals: 'العلامات الحيوية',
  handover: 'تسليم الوردية',
  shift_handover: 'تسليم الوردية',
  admission: 'ملاحظة القبول',
  discharge: 'خروج',
  medication_admin: 'إعطاء الأدوية',
  fluid_balance: 'ميزان السوائل',
  care_plan: 'خطة التمريض',
};

export function getNoteTypeLabel(noteType, language = 'en') {
  if (language === 'ar') {
    return NOTE_TYPE_LABELS_AR[noteType] || noteType;
  }
  return NOTE_TYPE_LABELS[noteType] || noteType;
}
